module.exports = __webpack_public_path__ + "static/media/ReactChat.ed60bb17.png";